export enum EmployeeModalSection {
  ASSIGNED_VEHICLES = 'assignedVehicles',
  PLANNED_UNAVAILABILITIES = 'plannedUnavailabilities',
}
